import axios from 'axios';

import { REACT_APP_QWEALTH_API_V3 } from '@qwealth/qdata';

export const downloadAttachment = async (fileId: number): Promise<Blob> => {
  const response = await axios.get(`${REACT_APP_QWEALTH_API_V3}/s3File/download`, {
    params: { file_id: fileId },
    responseType: 'blob',
  });
  return response.data;
};

export const deleteAttachment = async (attachmentId: number | string, householdQID: string): Promise<void> => {
  await axios.delete(`${REACT_APP_QWEALTH_API_V3}/s3File/deleteAttachment`, {
    params: { attachment_id: attachmentId, household_qid: householdQID },
  });
};

export const deleteEmbeddedAttachments = async (ids: string[], householdQID: string): Promise<void> => {
  const uniqueIds = Array.from(new Set(ids));
  if (uniqueIds.length === 0) return;
  await Promise.all(
    uniqueIds.map(id =>
      axios.delete(`${REACT_APP_QWEALTH_API_V3}/s3File/deleteAttachment`, {
        params: { attachment_id: id, household_qid: householdQID },
      }),
    ),
  );
};
